/// <reference types="vite/client" />
import '../tailwind/input.css'
import { RouterPlugin } from './router/RouterPlugin'
import { useSettingStore } from './stores/setting'
import 'external-svg-loader'
import { createPinia, setActivePinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'

import App from '@/App.vue'
import AppVenue from '@/AppVenue.vue'
import { configureBrowserAxios } from '@/api/api'
import { mkRouter } from '@/router'
import { mkBrowserSentry } from '@/sentry'
import { useUserStore } from '@/stores/user'

configureBrowserAxios()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const router = mkRouter()

pinia.use(RouterPlugin(router))
setActivePinia(pinia)
const isVenueApp = useUserStore().isLoggedIn

const app = createApp(isVenueApp ? AppVenue : App)
app.use(pinia)
app.use(router)

if (import.meta.env.VUE_APP_VERSION) {
  mkBrowserSentry(app, router)
}
useSettingStore().fetch()
router.isReady().then(() => app.mount('#app'))
